import { render } from "./AddOrEditDepotDiscountGroup.html?vue&type=template&id=2c4fa5cf&scoped=true"
import script from "./AddOrEditDepotDiscountGroup.js?vue&type=script&lang=js"
export * from "./AddOrEditDepotDiscountGroup.js?vue&type=script&lang=js"

import "./AddOrEditDepotDiscountGroup.css?vue&type=style&index=0&id=2c4fa5cf&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4fa5cf"]])

export default __exports__